import * as z from "zod/v4";
import { aeoDateRangeInput } from "./types";

const competitorData_ = z.object({
  name: z.string(),
  mentions: z.number(),
  isYou: z.boolean().describe("True if this is the user's brand"),
});
export const competitorData: z.ZodType<CompetitorData> = competitorData_;
export interface CompetitorData extends z.infer<typeof competitorData_> {}

export const getCompetitorComparison = {
  name: "getCompetitorComparison" as const,
  input: aeoDateRangeInput,
  output: z.object({
    competitors: z.array(competitorData).describe("Top 6 + YOU"),
    youRank: z.number().describe("Rank of user's brand (1-indexed)"),
    youInTopSix: z.boolean(),
  }),
};
